<template>
  <div class="profile pt-2">
    <b-container>
      <b-row>

        <!-- White Ushr logo and version tooltip -->
        <b-col class="text-center" md="auto">
          <a href="https://dmp-maps.com/" target="_blank">
            <b-img class="logo" :src="dmpWhiteImg" width="37%"></b-img>
          </a>
          <div class="info-tooltip">
            <fa :icon="['fas', 'info-circle']" class="info-icon" />
            <span class="info-tooltip-text">
              DMP Map Management Platform
              <br />
              Version {{ this.version }}
              <br />
              Released {{ this.release_date }}
              <br />
            </span>
          </div>
        </b-col>

        <!-- User name, email, and role -->
        <b-col>
          <div id="user_details" class="text-center">
            <div class="make-inline-block text-left" style="font-size: 14.5px">
              <span class="pb-3" >{{ this.user.name }}</span>
              <br />
              <span class="pb-3">{{ this.user.email }}</span>
              <br />
              <span class="pb-3">{{ this.getFormattedUserRole() }}</span>
            </div>
            <br />
          </div>
        </b-col>

        <!-- Profile settings and Logout buttons -->
        <b-col md="auto">
          <div class="make-inline-block text-left clickable">
            <fa
              :icon="['fas', 'bars']"
              @click="toggleFeatureButtons()"
              :class="showFeatureButtons ? 'clicked' : ''"
              title="Settings"
            />
          </div>
          <br />
          <div class="make-inline-block text-left clickable mt-2">
            <b-img
              :src="logoutImg"
              width="20"
              height="20"
              title="Logout"
              @click="logout()"
            ></b-img>
          </div>
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
#user_details {
  margin-left: -20px;
}
.logo {
  margin-left: 10px;
  margin-top: 3px;
}
.make-inline-block {
  display: inline-block;
}
.text-left {
  text-align: left;
}
.info-icon {
  position: absolute;
}
.info-tooltip {
  position: relative;
  display: inline-block;
}
.info-tooltip .info-tooltip-text {
  visibility: hidden;
  width: 200px;
  font-size: 15px;
  top: -55px;
  margin-left: 30px;
  margin-top: 20px;
  background-color: #212529;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 200000;
}
.info-tooltip:hover .info-tooltip-text {
  visibility: visible;
}
.clicked {
  color: #21d886;
}
.user-profile-side-padding {
  padding-left: 10px;
  padding-right: 10px;
}
</style>

<script>

/* WEBGIS-2619 -- edit 4/10/2024 - We can get rid of these imports since they are obsolete */ 
// import logoutImg from '../../../assets/user_profile/logout.png'
// import profileImg from '../../../assets/user_profile/profile.png'
// import ushrWhiteImg from '../../../assets/ushrWhite.png'
export default {
  name: 'MMP_UserProfile',
  props: ['release_date', 'showFeatureButtons', 'user', 'version'],
  data(){
    return{
      logoutImg:require('../../../assets/user_profile/logout.png'),
      profileImg:require('../../../assets/user_profile/profile.png'),
      dmpWhiteImg:require('../../../assets/dmpWhite.png')
    }
  },
  methods: {

    /* edit 4/10/2024 - We can get rid of these methods since they are obsolete */ 
    // getLogoutImg() {
    //   return logoutImg
    // },
    // getProfileImg() {
    //   return profileImg
    // },
    // getUshrWhiteLogo() {
    //   return ushrWhiteImg
    // },
    getFormattedUserRole() {
      return this.user.role.replace('USHR Platform', 'DMP');
    },
    logout() {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('pid')
      this.$emit('clearCurrentPositionsInterval')
      this.$router.push({name: 'Login'})
    },
    toggleFeatureButtons() {
      if (this.showFeatureButtons) {
        this.$emit('getFeatureButtons', !this.showFeatureButtons)
      } else {
        this.$emit('getFeatureButtons', true)
      }
    }
  }
}
</script>
